import { IDefineCommand, ITypedModel, IModel, IQuery, IQueryMediator } from 'core-ts-types';
import { ILocationsDatasource } from '../../../views/sections/datasources/locations_datasource';
import { ISectionTimesDatasource } from '../../../views/sections/datasources/section_times_datasource';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';
import { ICampusesDatasource } from '../../../views/sections/datasources/campuses_datasource';
import { ITermSectionTypesDatasource } from '../../../views/term_courses/datasources/term_section_types_datasource';
import * as _4 from 'lodash4';
import { ISectionAvailabilityDatasource } from '../../../views/sections/datasources/section_availability_datasource';
import { ITermCoursesDatasource } from '../../../views/term_courses/datasources/term_courses_datasource';
import { ORM } from 'utility-ts-orm';
import { ITermPlannedCoursesDatasource } from '../../../views/term_courses/datasources/term_planned_courses_datasource';
import { ISection, ICourse } from '../../../interfaces/scheduler_interfaces';
import { ISectionLabelsDatasource } from '../../../views/sections/datasources/section_labels_datasource';

angular
  .module('capability-ng-scheduler')
  .service(
    'crnSearchCommand',
    function crnSearchCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCRNSearchModel: any,
      ngLocationsDatasource: ILocationsDatasource,
      ngSectionTimesDatasource: ISectionTimesDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngCampusesDatasource: ICampusesDatasource,
      ngSectionLabelsDatasource: ISectionLabelsDatasource,
      ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngTermPlannedCoursesDatasource: ITermPlannedCoursesDatasource,
      ngCRNSearchResultsQuery: IQuery,
      QueryMediator: IQueryMediator,
      log: any
    ) {
      'use strict';

      return defineCommandORM('crnSearchCommand', function crnSearchCommand(deferred, termId, crn) {
        // reg/sections/term/<term_id>/search?crn=''&is_exact=True/False.
        $http
          .get(`/reg/sections/term/${termId}/search?crn=${crn}`)
          .then((response: any) => {
            const unPlannedCourses = _4.filter(response.data.planned_course, (course: ICourse) => course.id < 0);
            const sectionIds = _4.compact(_4.map(response.data.section, (section: ISection) => section.id));
            const unPlannedCourseIds = _4.map(unPlannedCourses, 'course');
            const totalMatchCount = _4.get(response.data, 'total_match_count', 0);
            ngCRNSearchModel.clear().write({ sectionIds, unPlannedCourseIds, totalMatchCount });
            ngLocationsDatasource.write(response.data.location);
            ngSectionLabelsDatasource.write(response.data.section_labels);
            ngSectionTimesDatasource.write(response.data.section_time);
            ngCampusesDatasource.write(response.data.campus);
            ngTermSectionTypesDatasource.write(response.data.section_type);
            ngSectionAvailabilityDatasource.write(response.data.section_status);
            ngTermPlannedCoursesDatasource.write(response.data.planned_course);
            ngTermCoursesDatasource.write(response.data.course);
            ngSectionsDatasource.write(response.data.section);
            deferred.resolve(response.data);
          })
          .catch((e: any) => {
            log.issue('failed to save term commitment preferences');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/commands/crn_search_command.ts